import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f52e54d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-color-red"
}
const _hoisted_2 = { class: "flex flex-justify-between" }
const _hoisted_3 = { class: "dialog-button" }
const _hoisted_4 = {
  key: 0,
  class: "text-color-red"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_row = _resolveComponent("row")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_add_dialog = _resolveComponent("add-dialog")!
  const _component_app_page = _resolveComponent("app-page")!

  return (_openBlock(), _createBlock(_component_app_page, null, {
    fheader: _withCtx(() => [
      _createVNode(_component_el_form, {
        class: "label",
        "label-width": "110px",
        ref: "ruleFormRef",
        rules: _ctx.rules,
        model: _ctx.formData
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "项目名称:",
            prop: "projectName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.projectName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.projectName) = $event)),
                style: {"width":"100%","color":"red"},
                filterable: "",
                "allow-create": _ctx.isAllowCreate,
                clearable: "",
                remote: "",
                "reserve-keyword": "",
                placeholder: "请选择对应的项目",
                onClear: _ctx.handleClear,
                "remote-method": _ctx.handleRemoteMethod,
                onChange: _ctx.handleSelectItem
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectNameList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.projectName,
                      label: item.projectName,
                      value: item.projectName
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "allow-create", "onClear", "remote-method", "onChange"]),
              (_ctx.projectTip)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, " 你将新建【" + _toDisplayString(_ctx.formData.projectName) + "】 项目 ", 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "域名地址",
            prop: "domainName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "选择项目后自动填入（未添加过则需要手动输入）",
                modelValue: _ctx.formData.domainName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.domainName) = $event)),
                disabled: _ctx.IsDisabled
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.handleAddFirstMenu
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 新增一级菜单 ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.firstTableList.length)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "warning",
                disabled: !_ctx.selected.length,
                onClick: _ctx.handleDeleteFirstMenu
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 删除一级菜单 ")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, { onClick: _ctx.handleBack }, {
            default: _withCtx(() => [
              _createTextVNode(" 取消 ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.handleSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 提交 ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    main: _withCtx(({ height }) => [
      (_ctx.firstTableList.length)
        ? (_openBlock(), _createBlock(_component_el_table, {
            data: _ctx.firstTableList,
            style: {"width":"100%"},
            height: height,
            key: height,
            "row-key": _ctx.handleRowKey,
            onSelectionChange: _ctx.handleSelectionChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                width: "55"
              }),
              _createVNode(_component_el_table_column, { type: "expand" }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_form, {
                    "label-width": "150px",
                    style: {"max-width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "服务类型：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    placeholder: "请选择",
                                    style: {"width":"100%"},
                                    clearable: "",
                                    modelValue: row.firstList.serviceType,
                                    "onUpdate:modelValue": ($event: any) => ((row.firstList.serviceType) = $event)
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.HANDLE_SERVICE_TYPE_LIST, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "后端服务：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: row.firstList.serviceName,
                                    "onUpdate:modelValue": ($event: any) => ((row.firstList.serviceName) = $event),
                                    style: {"width":"100%"},
                                    filterable: "",
                                    clearable: "",
                                    remote: "",
                                    "reserve-keyword": "",
                                    placeholder: "请选择关联后端服务",
                                    onFocus: _ctx.handleSearchService,
                                    onChange: ($event: any) => (_ctx.handleSelectServiceItem($event, row.firstList))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.servicesList, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.serviceName,
                                          label: item.serviceName,
                                          value: item.serviceName
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onFocus", "onChange"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "后端第一负责人：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    disabled: "",
                                    modelValue: row.firstList.firstHeadBackend,
                                    "onUpdate:modelValue": ($event: any) => ((row.firstList.firstHeadBackend) = $event),
                                    placeholder: "关联后端服务后自动输入"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "后端备选负责人：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    disabled: "",
                                    modelValue: row.firstList.secondHeadBackend,
                                    "onUpdate:modelValue": ($event: any) => ((row.firstList.secondHeadBackend) = $event),
                                    placeholder: "关联后端服务后自动输入"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "前端第一负责人：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    type: "text",
                                    style: {"width":"100%"},
                                    filterable: "",
                                    remote: "",
                                    clearable: "",
                                    "reserve-keyword": "",
                                    modelValue: row.firstList.headOfDevelopment,
                                    "onUpdate:modelValue": ($event: any) => ((row.firstList.headOfDevelopment) = $event),
                                    loading: _ctx.fuzzyLoading,
                                    "remote-method": _ctx.fuzzyRemoteMethod,
                                    onChange: ($event: any) => (_ctx.handleSelectRemoteItem($event, row.firstList, _ctx.FIRST_PEOPLE_ENUM.DEVELOPMENT_FIRST))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fuzzyResponse, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          value: item,
                                          label: `${item.label}${item.bbCode}`,
                                          key: item.value
                                        }, null, 8, ["value", "label"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "loading", "remote-method", "onChange"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "前端备选负责人：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    type: "text",
                                    style: {"width":"100%"},
                                    remote: "",
                                    filterable: "",
                                    clearable: "",
                                    modelValue: row.firstList.secondHeadOfDevelopment,
                                    "onUpdate:modelValue": ($event: any) => ((row.firstList.secondHeadOfDevelopment) = $event),
                                    loading: _ctx.fuzzyLoading,
                                    "remote-method": _ctx.fuzzyRemoteMethod,
                                    onChange: ($event: any) => (_ctx.handleSelectRemoteItem($event, row.firstList, _ctx.FIRST_PEOPLE_ENUM.DEVELOPMENT_SECOND))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fuzzyResponse, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          value: item,
                                          label: `${item.label}${item.bbCode}`,
                                          key: item.value
                                        }, null, 8, ["value", "label"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "loading", "remote-method", "onChange"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "测试第一负责人：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    type: "text",
                                    style: {"width":"100%"},
                                    remote: "",
                                    filterable: "",
                                    clearable: "",
                                    modelValue: row.firstList.headOfTest,
                                    "onUpdate:modelValue": ($event: any) => ((row.firstList.headOfTest) = $event),
                                    loading: _ctx.fuzzyLoading,
                                    "remote-method": _ctx.fuzzyRemoteMethod,
                                    onChange: ($event: any) => (_ctx.handleSelectRemoteItem($event, row.firstList, _ctx.FIRST_PEOPLE_ENUM.TEST_FIRST))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fuzzyResponse, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          value: item,
                                          label: `${item.label}${item.bbCode}`,
                                          key: item.value
                                        }, null, 8, ["value", "label"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "loading", "remote-method", "onChange"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "测试备选负责人：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    type: "text",
                                    style: {"width":"100%"},
                                    remote: "",
                                    filterable: "",
                                    clearable: "",
                                    modelValue: row.firstList.secondHeadOfTest,
                                    "onUpdate:modelValue": ($event: any) => ((row.firstList.secondHeadOfTest) = $event),
                                    loading: _ctx.fuzzyLoading,
                                    "remote-method": _ctx.fuzzyRemoteMethod,
                                    onChange: ($event: any) => (_ctx.handleSelectRemoteItem($event, row.firstList, _ctx.FIRST_PEOPLE_ENUM.TEST_SECOND))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fuzzyResponse, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          value: item,
                                          label: `${item.label}${item.bbCode}`,
                                          key: item.value
                                        }, null, 8, ["value", "label"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "loading", "remote-method", "onChange"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { prop: "firstLevelMenu" }, {
                default: _withCtx(({ row, $index }) => [
                  _createVNode(_component_el_form, {
                    "label-width": "100px",
                    style: {"width":"100%"},
                    ref: (el) => { if (el) _ctx.firstRuleFormRefList[$index] = el },
                    rules: _ctx.firstMenuRules,
                    model: row.firstList
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "一级菜单：",
                        prop: "firstLevelMenu"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 24,
                                style: {"width":"50%"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: row.firstList.firstLevelMenu,
                                    "onUpdate:modelValue": ($event: any) => ((row.firstList.firstLevelMenu) = $event),
                                    style: {"width":"100%"},
                                    filterable: "",
                                    clearable: "",
                                    "allow-create": "",
                                    onKeyup: _withKeys(_ctx.handleAddFirstMenu, ["enter"]),
                                    onChange: ($event: any) => (_ctx.handleShowTip($event, row)),
                                    placeholder: "请选择一级菜单（未添加过将会新建，按enter添加下一条）"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstMenuOptions, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item,
                                          label: item,
                                          value: item
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onKeyup", "onChange"]),
                                  (row.isShowTip)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, " 你将新建【" + _toDisplayString(row.firstList.firstLevelMenu) + "】一级菜单 ", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "default",
                            style: {"margin-left":"15px"},
                            onClick: ($event: any) => (_ctx.handleSecondsMenu(row.firstList, $index))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 新增二级菜单 ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["rules", "model"])
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["data", "height", "row-key", "onSelectionChange"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_add_dialog, {
        modelValue: _ctx.addSecondsVisible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addSecondsVisible) = $event)),
        "menu-options": _ctx.options,
        onOnSuccess: _ctx.handleCallBack
      }, null, 8, ["modelValue", "menu-options", "onOnSuccess"])
    ]),
    _: 1
  }))
}